import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
	 state:{
		isManage: false,	// 是否为上货员
		role: 1,	// 当前设定的角色：1为消费者，2为上货员
		userInfo: {},	// 用户信息
		deviceId: null,	// 当前设备id
		serverStatus: false,	// 系统服务是否开启
		replenishNumner: '',	// 上货单编号（存在编号则表示存在未填写的上货单）
	},
})

export default store;


// WEBPACK FOOTER //
// ./src/common/store.js